module.exports = __webpack_public_path__ + "static/img/jlyq.565795d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jlyq.png
// module id = M9PM
// module chunks = 4